module.exports = __webpack_public_path__ + "img/tsc.4fb8e034.png";